
<ng-content></ng-content>
<app-title-setter [title]='title'></app-title-setter>
